const ROOT = '/'
const DASHBOARD = '/dashboard'
const ADMIN_HOME = `${DASHBOARD}/admin`
const ADMINRO_HOME = `${DASHBOARD}/adminro`
const CARRIER_HOME = `${DASHBOARD}/carrier`
const SUPPLIER_HOME = `${DASHBOARD}/suppliers`
const PROCUREMENT_HOME = `${DASHBOARD}/procurement`
const ONGOING_ROUTE = 'ongoing'
const EVOUCHERS_ROUTE = 'evouchers'
const LOGIN = 'login'
const TOKEN = 'token'
const LOGOUT = 'logout'
const ID = '/:id'
const TRADITIONAL = 'traditional'
export const TICKET_ROUTE = '/ticket'

export const ROUTE_KEYS = {
  ADMIN: {
    HOME: ADMIN_HOME,
    ONGOING: ADMIN_HOME + ONGOING_ROUTE,
    EVOUCHERS: ADMIN_HOME + EVOUCHERS_ROUTE,
    TICKET: ADMIN_HOME + TICKET_ROUTE,
    BLOCKTRAINS: `${ADMIN_HOME}/blocktrains`,
    HISTORIC: `${ADMIN_HOME}/historic`,
  },
  CARRIER: {
    HOME: CARRIER_HOME,
    ALL: `${CARRIER_HOME}/all`,
    EVOUCHERS: `${CARRIER_HOME}/${EVOUCHERS_ROUTE}`,
    VEHICLES: `${CARRIER_HOME}/vehicles`,
    TICKET: CARRIER_HOME + TICKET_ROUTE,
  },
  SUPPLIER: {
    HOME: SUPPLIER_HOME,
    BLOCKTRAINS: `${SUPPLIER_HOME}/blocktrains`,
    HISTORIC: `${SUPPLIER_HOME}/historic`,
    PREVIOUS: `${SUPPLIER_HOME}/previous`,
    TICKET: SUPPLIER_HOME + TICKET_ROUTE,
  },
  PROCUREMENT: { HOME: PROCUREMENT_HOME, TICKET: PROCUREMENT_HOME + TICKET_ROUTE },
  ADMINRO: {
    HOME: ADMINRO_HOME,
    ONGOING: ADMINRO_HOME + ONGOING_ROUTE,
    EVOUCHERS: ADMINRO_HOME + EVOUCHERS_ROUTE,
    TICKET: ADMINRO_HOME + TICKET_ROUTE,
    BLOCKTRAINS: `${ADMINRO_HOME}/blocktrains`,
    HISTORIC: `${ADMINRO_HOME}/historic`,
  },
  TICKET: DASHBOARD + TICKET_ROUTE,
  LOGIN: {
    HOME: LOGIN,
    TRADITIONAL: TRADITIONAL,
    SSO: 'sso',
    RECOVER: 'recover',
    CHANGE_PASSWORD: 'change-password',
    LOGIN_ERROR: 'login-error',
  },
  TOKEN,
  LOGOUT,
  DASHBOARD,
  ROOT,
  TICKET_ID: TICKET_ROUTE + ID,
}
